import React from 'react';
import { Accordion } from './ui/Accordion';
import { CheckCircleIcon, XCircleIcon, FileTextIcon, HelpCircleIcon } from 'lucide-react';
export function Terms() {
  return <Accordion title="Vilkår & Afklaringer" data-id="element-230">
      <div className="space-y-6" data-id="element-231">
        {/* Included/Not included */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-232">
          <div data-id="element-233">
            <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-234">
              Inkluderet
            </h3>
            <ul className="space-y-2" data-id="element-235">
              {['Levering af alle komponenter', 'Standard installation af manifold', 'Udlægning af rør i henhold til plan', 'Trykprøvning og indregulering', 'Dokumentation og brugervejledning', '2 års garanti på arbejde'].map((item, index) => <li key={index} className="flex items-start" data-id="element-236">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-237" />
                  <span className="ml-2 text-sm text-gray-700" data-id="element-238">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-239">
            <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-240">
              Ikke inkluderet
            </h3>
            <ul className="space-y-2" data-id="element-241">
              {['El-tilslutning (kræver autoriseret elektriker)', 'Gennembrydninger i bærende konstruktioner', 'Bortskaffelse af eksisterende installation', 'Maler- og murerarbejde', 'Møblering og rydning af arbejdsområde', 'Tilslutning til eksisterende varmekilde'].map((item, index) => <li key={index} className="flex items-start" data-id="element-242">
                  <XCircleIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-243" />
                  <span className="ml-2 text-sm text-gray-700" data-id="element-244">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
        {/* Standard terms */}
        <div className="bg-gray-50 rounded-xl p-4" data-id="element-245">
          <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-246">
            Standardvilkår
          </h3>
          <div className="space-y-3 text-sm text-gray-700" data-id="element-247">
            <p data-id="element-248">
              <span className="font-medium" data-id="element-249">Garanti:</span> Alle Roth-produkter
              har 10 års produktgaranti. Øvrige produkter følger producentens
              garantibestemmelser, typisk 2-5 år.
            </p>
            <p data-id="element-250">
              <span className="font-medium" data-id="element-251">Reklamation:</span> Eventuelle fejl
              og mangler skal anmeldes inden for 14 dage efter
              modtagelse/installation.
            </p>
            <p data-id="element-252">
              <span className="font-medium" data-id="element-253">Betaling:</span> 30% ved
              ordrebekræftelse, 70% ved levering. Finansiering kan arrangeres
              gennem vores partnere.
            </p>
            <p data-id="element-254">
              <span className="font-medium" data-id="element-255">Gyldighed:</span> Tilbuddet er
              gældende i 30 dage fra dags dato. Priser kan ændres ved større
              ændringer i valutakurser eller råvarepriser.
            </p>
            <p data-id="element-256">
              <span className="font-medium" data-id="element-257">Standarder:</span> Installationen
              udføres i henhold til DS 452 (termisk isolering) og DS 469
              (varmeanlæg).
            </p>
          </div>
        </div>
        {/* Links to datasheets */}
        <div data-id="element-258">
          <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-259">
            Datablade og DoP
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-260">
            {[{
            brand: 'Roth',
            product: 'Gulvvarmefordeler 6 afgr.'
          }, {
            brand: 'Roth',
            product: 'X-PERT S5® 16 mm'
          }, {
            brand: 'CompA',
            product: 'WiFi-termostat M30'
          }, {
            brand: 'CompB',
            product: 'Cirkulationspumpe'
          }, {
            brand: 'Roth',
            product: 'Adaptere M30→M28'
          }].map((item, index) => <button key={index} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-4 py-2 hover:bg-gray-50 transition-colors" data-id="element-261">
                <div className="flex items-center" data-id="element-262">
                  <FileTextIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-263" />
                  <span className="text-sm text-gray-700" data-id="element-264">
                    {item.brand} {item.product}
                  </span>
                </div>
                <HelpCircleIcon className="h-4 w-4 text-gray-400" data-id="element-265" />
              </button>)}
          </div>
        </div>
      </div>
    </Accordion>;
}